import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';

interface ReportsOverlayStoreValues {
  isOpen: boolean;
  propertyId?: string;
  companyId?: string;
}

interface ReportsOverlayStoreFunctions {
  /** Opens the Reports drawer over whatever page the reader is on, at the given scope. */
  open: (scope: { propertyId?: string; companyId?: string }) => void;
  close: () => void;
}

type ReportsOverlayStore = ReportsOverlayStoreValues & ReportsOverlayStoreFunctions;

/**
 * Whether the Reports catalog and export drawer are open as an overlay on top of the current page,
 * rather than as their own full-page route — so the timeline underneath stays visible (P40-64021).
 */
const useReportsOverlayStore: UseBoundStore<StoreApi<ReportsOverlayStore>> = create<ReportsOverlayStore>()(set => ({
  isOpen: false,
  open: ({ propertyId, companyId }) => set({ isOpen: true, propertyId, companyId }),
  close: () => set({ isOpen: false })
}));

export default useReportsOverlayStore;
